#import "../../../../common/components/DocumentPackageEmail/EmailDocumentFields.graphql"
#import "../../../../common/components/DocumentPackageEmail/EntityEmailDocumentsFields.graphql"
mutation PurchaseOrderEmailCreate($input: PurchaseOrderEmailCreateInput!) {
  purchaseOrderEmailCreate(input: $input) {
    purchaseOrderEmail {
      __typename
      id
      _emailDocument {
        ...EmailDocumentFields
      }
      emailDocumentsByEntityId(orderBy: _CREATED_DATE_DESC) {
        nodes {
          ...EntityEmailDocumentsFields
        }
      }
    }
  }
}
